export const causesContainerId = crypto.randomUUID();
export const consequencesContainerId = crypto.randomUUID();
export const mitigatingControlsContainerId = crypto.randomUUID();
export const preventativeControlsContainerId = crypto.randomUUID();
